import { connect } from 'react-redux'
import { UpdatePasswordFormComponent } from './UpdatePasswordFormComponent'
import {
    resetPasswordUpdateSuccess,
    updatePassword
} from 'shared/store/kingdom/profile'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { ChangePasswordForm } from 'shared/types'

const mapStateToProps = (state: RootState) => state.kingdomProfilePageState

const mapDispatchToProps = (d: Dispatch<any>) => ({
    updatePassword: (form: ChangePasswordForm) => d(updatePassword(form)),
    resetPasswordSuccess: () => d(resetPasswordUpdateSuccess())
})

const UpdatePasswordForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdatePasswordFormComponent)

export { UpdatePasswordForm }
